import { render } from "./Exam.vue?vue&type=template&id=03c7dc5e&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"

import "./Exam.vue?vue&type=style&index=0&id=03c7dc5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c7dc5e"]])

export default __exports__